<form [formGroup]="_fS.tagForm">
    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 20, lg: 20 }">
        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="24" nzXl="24">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="tagNameError">
                    <label class="label-text required">Tag name</label>
                    <input class="input-group" nz-input formControlName="tagName" minlength="2" maxlength="40"
                        placeholder="Enter Tag Name" />
                    <ng-template #tagNameError let-control>
                        <ng-container *ngIf="control.hasError('required')">Please enter tag name
                        </ng-container>
                        <ng-container *ngIf="control.hasError('minlength')">Tag name must contain at least 2
                            characters
                        </ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="24" nzXl="24">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="tagGroupError">
                    <label class="label-text required">Tag group name</label>
                    <nz-select nzShowSearch nzPlaceHolder="Select Tag Group" [nzSize]="'default'"
                        formControlName="tagGroup" (ngModelChange)="checkTagGroupData($event)" [nzCustomTemplate]="defaultTemplate">
                        <ng-container *ngIf="!_cS.isLoadingTags">
                            <nz-option *ngFor="let option of listOfGroups" nzCustomContent [nzValue]="option._id"
                            [nzLabel]="option.Name" >
                            <span class="d-flex"><span class="rountTagGroupColor rount-tag"
                                    [ngStyle]="{'background-color':option.Color}"></span><span >{{option.Name}}</span></span>
                        </nz-option>
                        <nz-option *ngIf="_cS.isLoadingTags" nzDisabled nzCustomContent>
                            <span nz-icon nzType="loading" class="loading-icon"></span>
                            Loading Data...
                        </nz-option>
                    </ng-container>
                    </nz-select>
                    <ng-template #defaultTemplate let-selected>
                            <span class="d-flex"><span class="rountTagGroupColor rount-tag mt-13"
                                [ngStyle]="{'background-color':selectedTagGroup.Color}"></span><span >{{selected.nzLabel}}</span></span>
                      </ng-template>
                    <ng-template #tagGroupError let-control>
                        <ng-container *ngIf="control.hasError('required')">Please select tag group
                        </ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
        </div>
    </div>
</form>